import { Injectable } from '@angular/core';
import { indexOf } from 'lodash';
import { DisabledButtons } from '../../../pages/ui/components/buttons/components/disabledButtons';
import { MasterRepo } from '../../repositories';
import { disableDate } from './disableDate.model';
;

@Injectable()

export class DisableDateService{


    disableDate: disableDate[] = [];

    holidayResponse: any[];

    constructor( private masterRepo: MasterRepo ){
        this.holidayResponse = [];
    }

    setDisableDates(){
        return this.disableDate;
    }


    getDisableDates(){
        //console.log("GET DISABLE DATES");

        this.masterRepo.getHolidayList().subscribe(

            (res) => {  
            this.holidayResponse.push(res);
            },

            (err) => console.log(err),

            () => {                
            for( let x of this.holidayResponse ){
                //console.log(x);
                this.disableDate.push( { fromDate: x.BEGINDATE, toDate: x.ENDDATE } ); 
            }
            //console.log("DISABLE DATES", this.disableDate);
            
            return this.disableDate;
            } 
        
        )




    }
}